<div class="entity-config-page container-fluid">
  <div class="entity-config-shell d-flex flex-column gap-0 mx-auto">
    <section class="entity-config-top rounded-4 overflow-hidden shadow-sm mb-1">
      <div class="entity-config-top-hero px-2 px-md-2 pt-2 pb-1">
        <div class="row g-2 align-items-start">
          <div class="col">
            <div class="text-uppercase text-xxs text-white opacity-75 d-flex align-items-center gap-2 mb-2">
              <span>Home</span>
              <span>/</span>
              <span>Messages</span>
            </div>
            <h1 class="entity-page-title text-white fw-bold lh-sm mb-1">Messages</h1>
            <p class="entity-page-subtitle text-white mb-0 case-owner-messages-subtitle">
              Threads with requesters, panel members and internal coordinators. Channel-aware: an SMS to a requester goes out on the same number we used last time, and the audit trail keeps it together.
            </p>
          </div>
        </div>
      </div>

      <div class="px-2 px-md-2 pb-0">
        <section class="row g-2 mt-1">
          <div class="col-12 col-xl-3">
            <div class="entity-detail-panel entity-detail-panel-vibrant rounded-4 border-0 p-0 h-100 mt-0 overflow-hidden">
              <div class="entity-vibrant-binding-card rounded-4 bg-white border shadow-sm overflow-hidden h-100">
                <div class="px-3 pt-3 pb-2 border-bottom">
                  <div class="d-flex align-items-center gap-4 flex-wrap small">
                    <button
                      v-for="filter in filters"
                      :key="filter.key"
                      type="button"
                      class="btn btn-sm p-0 border-0 bg-transparent d-flex align-items-center gap-2"
                      :class="active_filter === filter.key ? 'fw-bold secondary-color' : 'text-secondary'"
                      @click="set_filter(filter.key)"
                    >
                      <span>{{ filter.label }}</span>
                      <span class="badge rounded-pill fw-normal bg-light text-secondary">{{ filter.count }}</span>
                    </button>
                  </div>
                </div>

                <div class="px-3 py-3 border-bottom">
                  <input type="text" class="form-control entity-binding-control" placeholder="Search messages..." />
                </div>

                <div class="d-flex flex-column">
                  <button
                    v-for="thread in filtered_threads"
                    :key="thread.id"
                    type="button"
                    class="btn text-start rounded-0 border-0 border-bottom px-3 py-3 case-owner-message-thread"
                    :class="thread.active ? 'case-owner-message-thread-active border-start border-3 border-success' : 'bg-white'"
                    @click="go_to_case_detail(thread.case_code)"
                  >
                    <div class="d-flex align-items-start gap-3">
                      <span class="avatar-circle text-white fw-bold flex-shrink-0 case-owner-message-avatar" :class="thread.initials_class">{{ thread.initials }}</span>
                      <div class="flex-grow-1 min-w-0">
                        <div class="d-flex align-items-start justify-content-between gap-2">
                          <div class="fw-bold text-dark text-xs">{{ thread.name }}</div>
                          <div class="text-xxs secondary-color">{{ thread.case_meta }}</div>
                        </div>
                        <div class="text-xs text-secondary text-truncate">{{ thread.preview }}</div>
                        <div class="d-flex align-items-center gap-2 flex-wrap mt-2">
                          <span class="badge rounded-pill fw-normal" :class="thread.tag_class">{{ thread.tag }}</span>
                          <span class="text-xxs secondary-color">{{ thread.case_code }}</span>
                          <span v-if="thread.activity" class="text-xxs secondary-color">{{ thread.activity }}</span>
                        </div>
                      </div>
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-xl-9">
            <div class="entity-detail-panel entity-detail-panel-vibrant rounded-4 border-0 p-0 h-100 mt-0 overflow-hidden">
              <div class="entity-vibrant-binding-card rounded-4 bg-white border shadow-sm overflow-hidden h-100 d-flex flex-column">
                <div class="px-3 py-3 border-bottom">
                  <div class="d-flex flex-column flex-lg-row align-items-lg-center justify-content-between gap-3">
                    <div class="d-flex align-items-center gap-3">
                      <span class="avatar-circle bg-success text-white fw-bold flex-shrink-0 case-owner-message-avatar">JM</span>
                      <div>
                        <div class="fw-semibold text-dark">Joseph Mokwena</div>
                        <div class="text-uppercase text-xxs secondary-color">
                          Requester - C-2026-0142 - SMS + WhatsApp
                        </div>
                      </div>
                    </div>

                    <div class="d-flex align-items-center gap-2">
                      <button type="button" class="btn btn-light btn-sm rounded-small border px-3">Call</button>
                      <button type="button" class="btn btn-light btn-sm rounded-small border px-3" @click="go_to_case_detail(active_thread_case_code)">View case</button>
                    </div>
                  </div>
                </div>

                <div class="px-3 py-3 flex-grow-1 overflow-auto case-owner-message-scroll">
                  <div class="d-flex flex-column gap-3">
                    <template v-for="group in message_items" :key="group.day_label">
                      <div class="text-uppercase text-xxs secondary-color text-center">{{ group.day_label }}</div>

                      <div
                        v-for="message in group.messages"
                        :key="`${group.day_label}-${message.meta}`"
                        class="d-flex"
                        :class="message.side === 'right' ? 'justify-content-end' : 'justify-content-start'"
                      >
                        <div
                          class="rounded-4 px-3 py-3 border shadow-sm case-owner-message-bubble"
                          :class="message.side === 'right' ? 'case-owner-message-bubble-outgoing text-white border-0' : 'bg-white text-dark'"
                        >
                          <div class="mb-2">{{ message.body }}</div>
                          <div class="text-uppercase text-xxs" :class="message.side === 'right' ? 'text-white opacity-75' : 'secondary-color'">
                            {{ message.meta }}
                          </div>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>

                <div class="px-3 py-3 border-top">
                  <div class="d-flex align-items-center justify-content-between gap-3 flex-wrap mb-2">
                    <div class="d-flex align-items-center gap-2 flex-wrap">
                      <button
                        type="button"
                        class="btn btn-sm rounded-pill px-3"
                        :class="channel === 'sms' ? 'btn-primary-dark' : 'btn-light border secondary-color'"
                        @click="set_channel('sms')"
                      >
                        SMS
                      </button>
                      <button
                        type="button"
                        class="btn btn-sm rounded-pill px-3"
                        :class="channel === 'whatsapp' ? 'btn-primary-dark' : 'btn-light border secondary-color'"
                        @click="set_channel('whatsapp')"
                      >
                        WhatsApp
                      </button>
                      <button
                        type="button"
                        class="btn btn-sm rounded-pill px-3"
                        :class="channel === 'email' ? 'btn-primary-dark' : 'btn-light border secondary-color'"
                        @click="set_channel('email')"
                      >
                        Email
                      </button>
                    </div>

                    <div class="d-flex align-items-center gap-2 flex-wrap">
                      <button type="button" class="btn btn-light btn-sm rounded-small border px-3">Attach</button>
                      <button type="button" class="btn btn-light btn-sm rounded-small border px-3">Template</button>
                    </div>
                  </div>

                  <textarea class="form-control entity-binding-control mb-3" rows="3" placeholder="Reply to Joseph... (SMS - max 160 chars per segment)"></textarea>

                  <div class="d-flex flex-column flex-lg-row align-items-lg-end justify-content-between gap-3">
                    <div class="small text-secondary">
                      All messages logged to C-2026-0142 audit trail - auto-translated to <span class="fw-bold text-dark">EN</span>
                    </div>

                    <div class="d-flex align-items-end gap-3">
                      <button type="button" class="btn btn-primary-dark rounded-small px-4 case-owner-message-send-btn">Send</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </section>
  </div>
</div>
